import type { UserColor } from '@kominiarz/shared';
import styles from './Avatar.module.css';

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('');

/** Initials on the person's calendar colour (the colour's own readable ink). */
export function Avatar({ name, color, size = 'md' }: { name: string; color: UserColor; size?: 'md' | 'lg' }) {
  return (
    <span
      className={`${styles.avatar} ${styles[size]}`}
      style={{ background: `var(--user-${color})`, color: `var(--user-${color}-ink)` }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
